import axios from 'axios';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as types from '../constants/actionTypes';
import * as api from '../tools/apiConfig';

export function getGapiAuth() {

    return function (dispatch, getState) {
        
        axios.get(api.GAPI_AUTH, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GAPI_AUTH, urlToRedirect: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}
export function putGapiToken(data, props) {
    
    return function (dispatch, getState) {

        axios.post(api.PUT_GAPI_TOKEN, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data == null) {
                        toast.info("Calendar Access Is Revoked")
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: false });
                    }
                    else {
                        props.history.push('/specialist/my-settings');
                        toast.info("Calendar Access Verified")
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: true });
                    }
                }
            })
            .catch(function (error) {
                

            });
    }
}

export function getUsersGoogleSyncStatus(data) {
    
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_GOOGLE_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function getOutlookAuth() {

    return function (dispatch, getState) {
        axios.get(api.OUTLOOK_AUTH, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GAPI_AUTH, urlToRedirect: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}

export function putOutlookToken(data, props) {
    
    return function (dispatch, getState) {
        axios.post(api.PUT_OUTLOOK_TOKEN, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data == null) {
                        toast.info("Outlook Calendar Access Is Revoked")
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: false });
                    }
                    else {
                        props.history.push('/specialist/my-settings');
                        toast.info("Sync to Outlook Calendar Successful")
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: true });
                    }
                }
            })
            .catch(function (error) {
                

            });
    }
}


export function getUsersOutlookSyncStatus(data) {
    
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_OUTLOOK_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_OUTLOOK_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function getUsersiCloudSyncStatus(data) {
    
    return function (dispatch, getState) {
        axios.post(api.GET_USERS_ICLOUD_SYNC_STATUS, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data == true) {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}


export function getiCalFile() {
    return function (dispatch) {
        axios.get(api.GET_iCAL_FILE, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info("Calendar Access Is Generated")
                    return dispatch({ type: types.GAPI_AUTH, urlToRedirect: response.data });
                }
            })
            .catch(function (error) {
            });
    }
}

export function storeUseriCloudEmail(data, props) {
    return function (dispatch, getState) {
        axios.post(api.STORE_USER_ICLOUD_EMAIL, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data) {
                        toast.info(response.data.message);
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        toast.info(response.data.message);
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}

export function removeiCalFromUser(data, props) {
    return function (dispatch, getState) {
        axios.post(api.REMOVE_USER_ICLOUD_EMAIL, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.token,
                'role': localStorage.userType
            }
        })
            .then(function (response) {
                
                if (response.data.code == 200) {

                    if (response.data.data) {

                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: true });
                    }
                    else {
                        return dispatch({ type: types.USER_ICLOUD_SYNC_OPTION, data: false });
                    }
                }
            })
            .catch(function (error) {

            });
    }
}